import Divider from "./divider.atom";

export default Divider;
